import { Input, Output, EventEmitter, Component, SimpleChanges, ViewChild, OnInit, OnChanges, OnDestroy } from '@angular/core';
import { Location } from '@angular/common';
import { Subject, Observable, defer } from 'rxjs';
import { AbstractDetailsComponent } from '../../shared/abstract-details.component';
import { ActivatedRoute } from '../../../../node_modules/@angular/router';
import { NgForm } from '../../../../node_modules/@angular/forms';
import { QuickeditService } from '../../../services/quickedit.service';


@Component({
	selector: 'asset-quickedit',
	templateUrl: './asset-quickedit.component.html',
	styleUrls: ['./asset-quickedit.component.scss']
})

export class AssetQuickeditComponent extends AbstractDetailsComponent implements OnInit, OnChanges, OnDestroy {
	@Input() row: any;
	@Input() mediaFormats: any[] = [];
	@Input() mediaclipType: 'video' | 'audio' | 'document' = 'video';

	@ViewChild('formRef', { static: true }) form: NgForm;

	@Output() saved: EventEmitter<any> = new EventEmitter<any>();
	@Output() removed: EventEmitter<any> = new EventEmitter<any>();
	@Output() canceled: EventEmitter<any> = new EventEmitter<any>();

	mediaTypeOptions: any[] = [];

	label = 'ASSET';
	mediaType: string;
	saveAction: Observable<void>;

	constructor(
		protected route: ActivatedRoute,
		protected quickeditService: QuickeditService,
		protected location: Location
	) {
		super(route, location);

		this.entityConfiguration = {
			name: 'mediaasset',
			entityTranslation: this.translate.instant('ASSET'),
			standAlone: true,
			parentPath: '/library/mediaclips',
			basePath: '/library/mediaclip/'
		};
	}

	ngOnInit() {
		if (this.row && this.row.data) {
			this.entity = this.row.data;
		}
		super.ngOnInit();

		this.saveAction = defer(() => this.save(true));
		this.quickeditService.addSaveAction(this.saveAction);
	}

	ngOnDestroy() {
		this.resetEntity();
		if (this.saveAction) {
			this.quickeditService.removeSaveAction(this.saveAction);
		}
	}

	ngOnChanges(simpleChanges: SimpleChanges) {
		if (simpleChanges && simpleChanges.mediaFormats) {
			this.mediaTypeOptions = this.mediaFormats.map((mediaFormat: string) => {
				if (this.row && this.row.data && this.row.data.jobdefid) {
					if (this.row.data.mediatype === mediaFormat) {
						this.mediaType = mediaFormat;
					}
				}

				return {
					value: mediaFormat,
					label: mediaFormat
				};
			});
		}
	}

	saveQuickEdit() {
		this.save(true).subscribe(() => {
			this.quickeditService.removeSaveAction(this.saveAction);
		});
	}

	save(force: boolean): Observable<void> {
		const saveSubject = super.save(force, null, false);

		saveSubject.subscribe((entity) => {
			if (this.isNew) {
				this.row.id = entity.id;
				this.row.data = entity;
				this.row.quickEditing = false;
			}
			this.saved.emit(entity);
		});
		return saveSubject;
	}

	delete(): Subject<void> {
		const deleteSubject = super.delete();

		deleteSubject.subscribe((response) => {
			this.removed.emit();
		});
		this.isNew = true;
		return deleteSubject;
	}

	resetEntity(emit = false) {
		this.cancel().subscribe((entity) => {
			this.row.data = entity;
			this.entity = entity;
			if (emit) {
				this.canceled.emit(entity);
			}
		});
	}

	onCancelClick() {
		if (this.isNew) {
			this.quickeditService.removeSaveAction(this.saveAction);
		} else {
			this.resetEntity();
			this.row.quickEditing = false; // this destroys this component.
		}
	}
}
